import { type FC } from 'react';

import ScheduleBooking, { type ScheduleBookingProps } from '@/components/Booking/ScheduleBooking';
import Modal from '@/components/Modal';

type Props = ScheduleBookingProps & {
  onClose: () => void;
};

const ScheduleBookingModal: FC<Props> = ({ onClose, ...restProps }) => (
  <Modal title='Schedule Booking' onClose={onClose}>
    <ScheduleBooking {...restProps} onSchedule={async () => onClose()} />
  </Modal>
);

export default ScheduleBookingModal;
